import {Video} from "mapping/video";
import {generateFullUrl} from "services/utils/utils";

export const Directory = {
    fromServer: (data) => {
        const videos = data.videos.map(Video.fromServer);
        const rawDirectory = data.directory;
        const unlocked = data.unlocked;
        return {
            id: rawDirectory.id,
            name: rawDirectory.title,
            categories: data.categories,
            tags: data.tags,
            created_at: rawDirectory.created_at,
            requires_payment: !unlocked.status,
            cost: rawDirectory.cost,
            min_level: unlocked.plan,
            image: generateFullUrl(rawDirectory.image),
            description: rawDirectory.description,
            speakers: data.authors,
            material: rawDirectory.links,
            videos,
            video_number: videos.length,
            total_duration: Math.round(videos.map(i => i.duration).reduce((a, b) => a + b, 0) / 60)
        }
    },
    toServer: (data) => {
        return {
            ...data
        }
    }
}